import {
  DOCUMENT_STATUS_FILTER_OPTIONS,
} from '#/modules/imsMgmt/receipts/shared/documentStatus';

export const STOCK_ISSUE_STATUS_FILTER_OPTIONS = DOCUMENT_STATUS_FILTER_OPTIONS;

export function canEditStockIssueDraft(status) {
  return status === 'DRAFT';
}

export function canEditStockIssue(status) {
  return canEditStockIssueDraft(status);
}

export function canEditStockIssueRemark(status) {
  return status === 'COMPLETED';
}

export function canSubmitStockIssue(status) {
  return status === 'DRAFT';
}

export function canCancelStockIssue(status) {
  return status === 'DRAFT';
}

export function canApproveStockIssue(status) {
  return status === 'SUBMITTED';
}

export function canRejectStockIssue(status) {
  return status === 'SUBMITTED';
}
